import React from "react";
import { TemplateWrapped } from "../../Layout";
import Select from "react-select";
import FileUpload from "./components/file-upload/FileUpload";
import { useSupport } from "./hooks/useSupport";
import { ticketCategories } from "./constants";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MdOutlineChatBubbleOutline } from "react-icons/md";
import "./index.css";
import withSelectedPractices from "../../HOCS/withSelectedPractices/withSelectedPractices";

const supportSelectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: 34,
    borderColor: "#d8d8d8",
    borderRadius: 5,
    boxShadow: "none",
    fontSize: 14,
    "&:hover": {
      borderColor: "#c8c8c8",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#7d7d7d",
    fontWeight: 400,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 11px",
  }),

  menu: (provided) => ({
    ...provided,
    zIndex: 5,
  }),
};

const Support = () => {
  const {
    inputRef,
    setPracticeSelected,
    practiceSelected,
    practiceOptions,
    formInputs,
    setFormInputs,
    setCategorySelected,
    categorySelected,
    handleSubmit,
    handleCancel,
    files,
    isLoading,
    handleChange,
    handleRemoveFile,
    handleClick,
    handleDragOver,
    handleDrop,
  } = useSupport();

  return (
    <TemplateWrapped
      title="Support"
      headerButtons={<React.Fragment></React.Fragment>}
    >
      <div className="support-page">
        <div className="support-card">
          <form onSubmit={handleSubmit}>
            <div className="support-card__header">
              <div className="support-card__icon">
                <MdOutlineChatBubbleOutline />
              </div>
              <h2>Support Center</h2>
            </div>

            <div className="support-card__body">
              <p className="support-required-note">
                Fields marked with <span>*</span> are required.
              </p>

              <div className="support-field">
                <label htmlFor="support-subject">
                  Subject <span>*</span>
                </label>
                <input
                  id="support-subject"
                  className="support-input"
                  placeholder="Brief summary of your request..."
                  value={formInputs.ticketName}
                  onChange={(e) =>
                    setFormInputs({
                      ...formInputs,
                      ticketName: e.target.value,
                    })
                  }
                  required
                />
              </div>

              <div className="support-field">
                <label htmlFor="support-practice">
                  Office / Clinic Name <span>*</span>
                </label>
                <Select
                  inputId="support-practice"
                  placeholder="Type your office name..."
                  styles={supportSelectStyles}
                  value={practiceSelected}
                  onChange={(newValue) => setPracticeSelected(newValue)}
                  options={practiceOptions}
                  isMulti
                  required
                />
              </div>

              <div className="support-field">
                <label htmlFor="support-request-type">
                  Request Type <span>*</span>
                </label>
                <Select
                  inputId="support-request-type"
                  placeholder="Select the option that best describes your request"
                  styles={supportSelectStyles}
                  value={categorySelected}
                  onChange={(newValue) => setCategorySelected(newValue)}
                  options={ticketCategories}
                />
              </div>

              <div className="support-field">
                <label htmlFor="support-description">
                  Description <span>*</span>
                </label>
                <div className="support-description-info">
                  <p>
                    If your request is related to an issue involving one or more
                    patients, please make sure to include the following
                    information:
                  </p>
                  <ul>
                    <li>Patient name</li>
                    <li>Date of birth</li>
                    <li>Appointment date</li>
                    <li>Insurance carrier</li>
                    <li>Office / clinic</li>
                  </ul>
                  <p>
                    Providing these details will help us review and resolve your
                    request more efficiently.
                  </p>
                </div>
              </div>
              <textarea
                id="support-description"
                className="support-input support-textarea"
                placeholder="Please describe the issue, request or question in detail..."
                maxLength={2000}
                value={formInputs.description}
                onChange={(e) =>
                  setFormInputs({
                    ...formInputs,
                    description: e.target.value,
                  })
                }
                required
              />
              <div className="support-field" style={{ display: "none" }}>
                <label htmlFor="support-video-url">Video URL Link</label>
                <input
                  id="support-video-url"
                  type="url"
                  className="support-input"
                  placeholder="Add a related link (https://...)"
                  value={formInputs.url || ""}
                  onChange={(e) =>
                    setFormInputs({
                      ...formInputs,
                      url: e.target.value,
                    })
                  }
                />
              </div>

              <FileUpload
                inputRef={inputRef}
                handleChange={handleChange}
                handleRemoveFile={handleRemoveFile}
                handleClick={handleClick}
                handleDragOver={handleDragOver}
                handleDrop={handleDrop}
                files={files}
              />
            </div>

            <div className="support-card__footer">
              <span className="support-ticket-code">TKT-68065</span>
              <div className="support-actions">
                <Button
                  className="support-button support-button--secondary"
                  type="button"
                  variant="light"
                  onClick={handleCancel}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <Button
                  className="support-button support-button--primary"
                  type="submit"
                  variant="primary"
                  disabled={isLoading}
                >
                  {isLoading && (
                    <FontAwesomeIcon
                      icon="spinner"
                      spin
                      style={{ marginRight: 8 }}
                    />
                  )}
                  {isLoading ? "Submitting..." : "Submit Ticket"}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </TemplateWrapped>
  );
};

export default withSelectedPractices(Support);
